var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 85",
    style: {
      enableBackground: "new 0 0 300 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FAFAFA;}\n\t.st1{fill:#F8F8F8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,46.6H0V36C0,36,22.5,9.6,150,9.6S300,36,300,36V46.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.5,71.7C143,64,117.1,50.8,85.6,46.3c-20.9-3-54.2-3.6-85.9,13.9v25.3H300V66.4c-8.6,2.6-25.9,7.1-47.7,9.5 C225.7,78.9,197.7,78.2,172.5,71.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.3,67.3c-25.5,0-50.1-4.3-73.1-11c-22.5-6.6-44.1-14.4-68.5-17.9c-18.5-2.7-46.7-3.5-74.9,8.5 C41.1,36,69.7,38.4,88,42.1c23.8,4.9,44.2,13.9,65.7,21.7c9.9,3.6,20.5,6.9,31.1,9.6c12.9,3.3,26.1,5.1,39.6,5.1 c0.6,0,1.2,0,1.8,0.1c8.8-0.1,17.6-0.7,26.3-1.7c21.8-2.5,39.1-7,47.7-9.5v-9.7C300,57.7,251.6,67.4,227.3,67.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234,49.4c-25.2,2.4-50.6,0.5-75-3.9c-23.8-4.3-47.1-10-72.1-11.1c-5-0.2-10.7-0.3-16.8,0.1 c7,0,13.4,0.5,19,1.2c24.6,3,46.7,10.3,69.5,16.4c23.4,6.2,48.2,10,73.7,9.4C256.7,61,300,50.3,300,50.3V33.2 C300,33.2,258.1,47.2,234,49.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg_1.1b3e7901cbd53b841457e0d2012d8dbc.svg";
export { ForwardRef as ReactComponent };